import { workflowsRoutes } from "@circle-react/lib/routes/workflows";

import { t } from "@/i18n-js/instance";

import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const useWorkflowLinks = (): Link[] => [
  {
    label: t("settings_nav_v3.workflows.all"),
    path: workflowsRoutes.list(),
    exact: true,
  },
  {
    label: t("settings_nav_v3.workflows.history"),
    path: workflowsRoutes.history(),
    exact: true,
  },
];

export const WorkflowLinks = () => {
  const links = useWorkflowLinks();

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t("settings_nav_v3.workflows.label")}>
        {links.map(link => (
          <SubNavLinkItem key={link.path} label={link.label} to={link.path} />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
